// chatFun.js — Effets d'ambiance FUN pour le chat (100% client, gratuits, sans dépendance).
// • screenShake() : petite secousse (sticker dynamite 🧨).
// • confetti()    : pluie de confettis (sticker victoire 🏆).
// • stickerEffect(id) : déclenche l'effet associé à un sticker Worms reçu.

let styleInjected = false;
function injectStyle() {
  if (styleInjected) return; styleInjected = true;
  const s = document.createElement('style');
  s.textContent = `
    @keyframes vgShake{0%,100%{transform:translate(0,0)}20%{transform:translate(-6px,3px)}40%{transform:translate(6px,-3px)}60%{transform:translate(-4px,2px)}80%{transform:translate(4px,-2px)}}
    .vg-shake{animation:vgShake .5s ease}
    @keyframes vgFall{to{transform:translateY(105vh) rotate(720deg);opacity:.9}}
  `;
  document.head.appendChild(s);
}

export function screenShake() {
  injectStyle();
  const el = document.body; if (!el) return;
  el.classList.remove('vg-shake'); void el.offsetWidth; el.classList.add('vg-shake');
  setTimeout(() => el.classList.remove('vg-shake'), 550);
}

export function confetti(n = 80) {
  injectStyle();
  const box = document.createElement('div');
  box.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:99999;overflow:hidden';
  const colors = ['#7c3aed', '#06b6d4', '#ef4444', '#22c55e', '#f59e0b', '#ec4899'];
  for (let i = 0; i < n; i++) {
    const p = document.createElement('div');
    const size = 6 + Math.random() * 8;
    p.style.cssText = `position:absolute;top:-20px;left:${Math.random() * 100}vw;width:${size}px;height:${size * 0.6}px;` +
      `background:${colors[i % colors.length]};border-radius:2px;opacity:.95;` +
      `animation:vgFall ${1.6 + Math.random() * 1.6}s linear ${Math.random() * 0.4}s forwards;transform:rotate(${Math.random() * 360}deg)`;
    box.appendChild(p);
  }
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 3600);
}

// Déclenche l'effet lié à un sticker (appelé à la RÉCEPTION d'un message, pas au rendu de l'historique).
export function stickerEffect(id) {
  if (id === 'worm_boom') screenShake();
  else if (id === 'worm_win') confetti();
}
